export default __webpack_public_path__ + "static/focus-music-fd40cd426c7f7f378155052f8b4883ba.png";